import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

/**
 * A little helper to convert pure html string to Draft.js EditorState
 * @param {String} html must be valid html string
 *
 * @returns {Object} draft.js EditorState
 */
export function htmlToState(html) {
  const blocksFromHtml = htmlToDraft(html);
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(
    contentBlocks,
    entityMap,
  );

  return EditorState.createWithContent(contentState);
}

/**
 * A little helper to convert Draft.js EditorState to html string
 * @param {Object} state must be valid Draft.js EditorState instance
 *
 * @returns {String} html string
 */
export function stateToHtml(state) {
  const content = state.getCurrentContent();
  const rawState = convertToRaw(content);

  return draftToHtml(rawState);
}
